import queryString from "query-string";

const PATHNAME_TO_SOURCE_FROM_MAP = {
	"doubletake": "Doubletake",
	"match": "Discovery",
	"who-likes-you": "Likes",
	"who-you-like": "Likes",
	"messages": "Messages",
	"upgrade": "Alist",
	"settings": "Settings",
	"profile": "Profile",
	"flagmod": "Flag mod",
	"home": "Home",
};

export default function sourceFromPathname() {
	const { location: { pathname } } = window;
	const firstPathname = pathname.substr(1).split("/")[0];

	return PATHNAME_TO_SOURCE_FROM_MAP[firstPathname];
}

// ---------------------------------------------------------

const CF_TO_SOURCE = {
	default: "direct",
	discovery: "discovery",
	doubletake: "doubletake",
	messageThread: "message thread",
	matchSearch: "search",
	likesIncoming: "who likes you",
	likesOutgoing: "who you like",
	intros: "intros",
};

export const sourceFromCF = () => {
	const cf = queryString.parse(window.location.search).cf;

	if (!cf) {
		return CF_TO_SOURCE.default;
	}

	let res;

	if (cf.indexOf("intros") >= 0) {
		res = CF_TO_SOURCE.intros;
	} else if (cf.indexOf("quickmatch") >= 0 || cf.indexOf("doubletake") >= 0) {
		res = CF_TO_SOURCE.doubletake;
	} else if (cf.indexOf("discovery") >= 0) {
		res = CF_TO_SOURCE.discovery;
	} else if (cf.indexOf("messenger") >= 0) {
		res = CF_TO_SOURCE.messageThread;
	} else if (cf.indexOf("matchsearch") >= 0) {
		res = CF_TO_SOURCE.matchSearch;
	} else if (cf.indexOf("likesIncoming") >= 0) {
		res = CF_TO_SOURCE.likesIncoming;
	} else if (cf.indexOf("likesOutgoing") >= 0) {
		res = CF_TO_SOURCE.likesOutgoing;
	}

	return res;
};



// WEBPACK FOOTER //
// ./src/analytics/util/source.js